'use strict';

const baseProfileSFSC = require('core/profile/profileSFSC');

/**
 * The base fillDropdowns() wipes the province/city options and appends the
 * fetched values only, so the browser auto-selects the first entry. QA rule:
 * whenever the country is selected (or comes prefilled) the province and city
 * selects must reset to the "Select" placeholder, disabled and hidden so it
 * cannot be re-chosen.
 */

// Grabs the server-rendered placeholder so text/attributes stay localized
function capturePlaceholder($select) {
  const $opt = $select.find('option[data-placeholder]').first();
  return $opt.length ? $opt.prop('outerHTML') : '<option value="" data-placeholder disabled hidden>Select</option>';
}

// Re-inserts the placeholder after a repopulation; restores restoreValue when
// it is still available in the new option list, otherwise lands on the placeholder
function restorePlaceholder($select, placeholderHtml, restoreValue) {
  if (!$select.length) return;

  // GeoDBUtils unshifts a selectable pseudo-placeholder (empty id, field-label
  // text) into every list — drop it, our disabled+hidden placeholder replaces it
  $select.find('option[value=""]:not([data-placeholder])').remove();

  if (!$select.find('option[data-placeholder]').length) {
    $select.prepend(placeholderHtml);
  }

  if (restoreValue && $select.find('option[value="' + restoreValue + '"]').length) {
    $select.val(restoreValue);
  } else {
    $select.val('');
  }
}

module.exports = {
  handleSelectedDropdowns: function () {
    const $countryDropdown = $('.js_sfsc-countries');
    const $provinceDropdown = $('.js_sfsc-provinces');
    const $cityDropdown = $('.js_sfsc-cities');

    // Server-rendered state, captured before any AJAX wipes it: placeholders
    // to re-insert and the prefilled values to restore on the initial load
    // (edit profile). User-driven changes always reset to the placeholder.
    const provincePlaceholder = capturePlaceholder($provinceDropdown);
    const cityPlaceholder = capturePlaceholder($cityDropdown);
    let pendingProvince = $provinceDropdown.val() || null;
    let pendingCity = $cityDropdown.val() || null;

    // Run the base profileSFSC logic first to set up all AJAX handlers
    baseProfileSFSC.handleSelectedDropdowns();

    let isInitialLoad = true;

    $(document).ajaxSuccess(function (event, xhr, settings) {
      if (!settings.url || settings.url.indexOf('SFSCUtils-GetDataAsJSON') === -1) return;

      // The province-change fetch carries the province param and returns cities;
      // the country-change fetch returns provinces (and leaves cities emptied)
      const isCityFetch = settings.url.indexOf('province=') !== -1;

      if (!isCityFetch) {
        restorePlaceholder($provinceDropdown, provincePlaceholder, pendingProvince);
        pendingProvince = null;
      }
      restorePlaceholder($cityDropdown, cityPlaceholder, isCityFetch ? pendingCity : null);
      if (isCityFetch) {
        pendingCity = null;
      }

      // SFSC dropdowns repopulated — refresh the MMSelect decorators
      $provinceDropdown.each(function () {
        this.dispatchEvent(new CustomEvent('MMSelect:refresh'));
      });
      $cityDropdown.each(function () {
        this.dispatchEvent(new CustomEvent('MMSelect:refresh'));
      });

      // For pre-selection on load:
      if (isInitialLoad) {
        // If a province value was restored, trigger its change to load the cities
        if ($provinceDropdown.val()) {
          $provinceDropdown.trigger('change');
        }
        isInitialLoad = false;
      }
    });

    // Let's trigger country change on load to initialize provinces/cities
    if ($countryDropdown.val()) {
      $countryDropdown.trigger('change');
    }
  }
};
